import React from "react";
import {Link as RouterLink} from "react-router-dom";
import {AspectRatio, Box, Heading, Image, Text} from "@chakra-ui/react";
import {ArrowForwardIcon} from "@chakra-ui/icons";
import {imageUrl, subCategoryUrl} from "../data/catalog";

function SubCategoryCard({category, sub}) {
    const count = sub.img_urls.length;
    return (
        <Box as={RouterLink} to={subCategoryUrl(category, sub)} data-group display="flex" flexDirection="column" bg="white"
             border="1px solid" borderColor="ink.100" transition="box-shadow 0.3s, border-color 0.3s"
             _hover={{boxShadow: "0 18px 40px rgba(0,0,0,0.12)", borderColor: "transparent"}}>
            <AspectRatio ratio={1} overflow="hidden" bg="ink.100">
                <Image src={imageUrl(sub.img_urls[0])} alt={sub.description} loading="lazy" objectFit="cover"
                       transition="transform 0.6s ease" _groupHover={{transform: "scale(1.05)"}}/>
            </AspectRatio>
            <Box p={{base: 5, md: 6}} flex={1} display="flex" flexDirection="column">
                <Text fontSize="xs" letterSpacing="0.14em" textTransform="uppercase" color="ink.500">
                    {count} {count === 1 ? "photo" : "photos"}
                </Text>
                <Heading as="h3" fontSize="lg" lineHeight={1.35} mt={2} flex={1}>{sub.description}</Heading>
                <Text as="span" mt={5} fontSize="xs" fontWeight={700} letterSpacing="0.14em" textTransform="uppercase"
                      color="brand.500" display="inline-flex" alignItems="center" gap={2}>
                    View photos
                    <ArrowForwardIcon transition="transform 0.2s" _groupHover={{transform: "translateX(4px)"}}/>
                </Text>
            </Box>
        </Box>
    );
}

export default SubCategoryCard;
